import React from 'react'
import Banner from '../components/Banner'
import CoinsTable from '../components/CoinsTable'
import Loader from '../components/Loader'
const Homepage = () => {
    



    return (
        <div>
            <Banner />
            <CoinsTable />
            <Loader />
        </div>
    )
}

export default Homepage
